import { Divider } from '@mui/material';
import type { PerUnitProduct } from '@weft/services';
import { isPerUnitProductVariant } from '@weft/services';
import { isSingleItem } from '@weft/utils';
import cn from 'classnames';
import React from 'react';
import { useChargeContext } from '../../../charge-context';
import { PlanChargesContainer } from '../../../PlanChargesContainer';
import { UsageProductVariantHeaderView } from '../UsageProductVariantHeaderView';
import { UsageProductVariantSummary } from '../UsageProductVariantSummary';
import { PerUnitItem } from './per-unit-usage-charge-components/PerUnitItem';

export const PerUnitUsageCharge: React.FC = () => {
  const { item: product, itemIndex: productIndex, currency } = useChargeContext<PerUnitProduct>();

  const hasSummary = product.commitment || product.basePrice;
  const isGroupedProduct = product.variants.length > 1;

  return (
    <div className="flex flex-col gap-y-4">
      <PlanChargesContainer
        key={product.id}
        className={cn('px-0', hasSummary ? 'pt-5' : 'py-5')}
      >
        <div>
          <UsageProductVariantHeaderView
            name={isGroupedProduct ? product.name : undefined}
            className="px-8"
            isProductTitle
          />

          <div className="divide-frame grid grid-cols-1 gap-5 divide-y px-8">
            {product.variants.map((variant) => {
              if (!isPerUnitProductVariant(variant)) {
                return null;
              }

              return (
                <div
                  key={variant.id}
                  className={cn({ 'pt-5 first:pt-0': !isSingleItem(product.variants) })}
                >
                  <PerUnitItem
                    chunkSize={variant.pricing.priceConfiguration.chunkSize}
                    name={variant.name ?? variant.meter?.name ?? ''}
                    description={variant.description ?? undefined}
                    pricePerUnit={variant.pricing.priceConfiguration.price}
                    currency={currency}
                  />
                </div>
              );
            })}
          </div>
          {hasSummary && (
            <>
              <Divider sx={{ marginX: 3, paddingY: 1 }}/>
              <UsageProductVariantSummary {...{ product, isEditing: false, productIndex, editable: false, enterEditMode: () => {}, currency }} />
            </>
          )}
        </div>
      </PlanChargesContainer>
    </div>
  );
};